import * as React from "react";
import { SVGProps } from "react";
export const ClearFormattingIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11.0104 7.83334L8.9271 5.75001C8.69099 5.5139 8.63891 5.24307 8.77085 4.93751C8.9028 4.63195 9.13544 4.47918 9.46877 4.47918H15.5313C15.809 4.47918 16.0452 4.5764 16.2396 4.77084C16.434 4.96529 16.5313 5.2014 16.5313 5.47918C16.5313 5.75695 16.434 5.99307 16.2396 6.18751C16.0452 6.38195 15.809 6.47918 15.5313 6.47918H11.5938L11.0104 7.83334ZM16.0104 17.0625L9.7396 10.8125L8.40627 13.875C8.32294 14.0556 8.20141 14.2014 8.04169 14.3125C7.88196 14.4236 7.70488 14.4792 7.51044 14.4792C7.14933 14.4792 6.86808 14.3299 6.66669 14.0313C6.4653 13.7326 6.44099 13.4167 6.59377 13.0833L8.21877 9.29168L2.9271 4.00001C2.77433 3.84723 2.69794 3.67015 2.69794 3.46876C2.69794 3.26737 2.77433 3.09029 2.9271 2.93751C3.07988 2.78473 3.25696 2.70834 3.45835 2.70834C3.65974 2.70834 3.83683 2.78473 3.9896 2.93751L17.0729 16.0208C17.2257 16.1736 17.3021 16.3472 17.3021 16.5417C17.3021 16.7361 17.2257 16.9097 17.0729 17.0625C16.9202 17.2153 16.7431 17.2917 16.5417 17.2917C16.3403 17.2917 16.1632 17.2153 16.0104 17.0625Z"
            fill="currentColor"
        />
    </svg>
);
ClearFormattingIcon.displayName = "ClearFormattingIcon";
